import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'app-modal-erro',
    templateUrl: './modal-erro.component.html',
    styleUrls: ['./modal-erro.component.scss']
})
export class ModalErroComponent implements OnInit {
    static parseMsg(msg: string, tipo?: 'SUCCESS' | 'ERROR') {
        return msg.split('\n')
            .filter(line => line.trim() !== '')
            .map(line => {
                const match = RegExp(/Item \d+: (.+)/).exec(line);
                return match ? {tipo: tipo || 'ERROR', mensagem: match[0]} : {tipo: tipo || 'SUCCESS', mensagem: line};
            });
    }

    constructor(@Inject(MAT_DIALOG_DATA) public mensagens: { tipo: string, mensagem: string }[]) {
    }

    ngOnInit(): void {
    }

}
